import { Component } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
    selector: 'app-notfound',
    templateUrl: './notfound.component.html',
})
export class NotfoundComponent {

  animationNotFound: AnimationOptions = {
      path: 'assets/Animations/animationNotFoundPages.json',
    };
 }
